import { useEffect, useState } from "react";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

function truncate(text, max = 90) {
    if (!text) return "";
    return text.length > max ? text.slice(0,max) + "..." : text;
}

export default function FeaturedUseCases() {
    const [useCases, setUseCases] = useState([]);

    useEffect(() => {
        async function loadFeatured() {
            const ref = collection(db, "useCases");
            const q = query(ref, orderBy("title"), limit(2));
            const snap = await getDocs(q);

            const results = snap.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setUseCases(results)
        }
        loadFeatured();
    }, []);

    return (
        <div className="featuredUseCases">
            <h4>Featured Use Cases</h4>
            {useCases.map(uc => (
                <div key={uc.id} className="featuredCard">
                    <h3>{uc.title}</h3>
                    <p>{truncate(uc.description, 90)}</p>
                    <a href={`/useCases/${uc.id}`} className="viewLink">
                        View Details
                    </a>
                </div>
            ))}
        </div>
    )
}